import { HeadAgreementStatusCode } from "@/gql/graphql";
import { RouteAgreement } from "../../customers/customer-details/types";

export const routeAgreementStatusIsNotVoid = (
  ra: Pick<RouteAgreement, "statusCode">
): boolean => ra.statusCode !== HeadAgreementStatusCode.Void;
